export const enum ToServerCommand
{
  Error = 0,
  StartSession = 1,
  Event = 2,
  Close = 3,
  RewardImpressionPerSession = 4,
  InterImpressionPerSession = 5,
  Heartbeat = 6,
  AppVersion = 7,
  UpdateSession = 8,
}

export const enum ToClientCommand
{
  Error = 0,
  StartSessionResponse = 1,
  EventResponse = 2,
  CloseResponse = 3,
  AppVersion = 10,
}
